import script from "./TextareaBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextareaBase.vue?vue&type=script&setup=true&lang=ts"

import "./TextareaBase.vue?vue&type=style&index=0&id=68c18381&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68c18381"]])

export default __exports__